import { request } from '../../utils/request';

export type AddressSuggestion = {
  place_id: string;
  label: string;
  address: {
    label: string;
    district?: string;
    city?: string;
    state?: string;
    country?: string;
  };
};

export type AddressLookupResult = {
  place_id: string;
  label: string;
  coords: { lat: number; lng: number };
  address: {
    label: string;
    district?: string;
    city?: string;
    state?: string;
    country?: string;
    postal_code?: string;
  };
};

export const autocompleteAddress = (
  query: string,
  country = 'NGA'
): Promise<AddressSuggestion[]> =>
  request({
    method: 'GET',
    url: `/logistics/address/autocomplete`,
    params: { query, country },
  }) as Promise<AddressSuggestion[]>;

export const lookupAddress = (placeId: string): Promise<AddressLookupResult> =>
  request({
    method: 'GET',
    url: `/logistics/address/lookup`,
    params: { placeId },
  }) as Promise<AddressLookupResult>;

export const reverseGeocodeAddress = (
  lat: number,
  lng: number
): Promise<AddressLookupResult> =>
  request({
    method: 'GET',
    url: `/logistics/address/reverse-geocode`,
    params: { lat: String(lat), lng: String(lng) },
  }) as Promise<AddressLookupResult>;
